import React from 'react';
import { ArrowRightIcon, GiftIcon, LockIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { SectionBadge } from '../SectionBadge';
import { Reveal } from '../Reveal';
import { useLaunchCountdown } from '../../hooks/useLaunchCountdown';
import { BONOS, PRICING, PRICING_OPTIONS } from '../../data/content';
export function Pricing() {
  const {
    isExpired
  } = useLaunchCountdown();
  const megapack = PRICING_OPTIONS[0];
  if (!megapack) return null;
  return <section className="w-full px-5 py-12 sm:py-16" aria-labelledby="pricing-title" data-id="element-175" data-mp="3pj7wjgh9zxq7">
      <div className="mx-auto max-w-xl" data-id="element-176" data-mp="3uikrypm7qd4e">
        <Reveal className="text-center" data-id="element-177" data-mp="3ujm6j42fthqv">
          <SectionBadge tone="dark" data-id="element-178" data-mp="3ugrkx97otqvv">
            {isExpired ? 'Acceso disponible' : 'Oferta de lanzamiento'}
          </SectionBadge>
          <h2 id="pricing-title" tabIndex={-1} className="mt-5 font-display text-2xl leading-tight text-snow outline-none sm:text-4xl" data-id="element-179" data-mp="20531atqih055">
            Llevate hoy el <span className="u-lime" data-id="element-180" data-mp="253weel1vyp4s">sistema completo</span>
          </h2>
        </Reveal>

        <Reveal delay={90} className="mt-8" data-id="element-181" data-mp="1bc1gxr1px0wm">
          <article className="rounded-3xl border-2 border-lime bg-rose-deep p-6 shadow-[0_22px_50px_rgba(122,30,60,0.14)] sm:p-8" data-id="element-182" data-mp="16k9zc60ji5im">
            <header className="text-center" data-id="element-183" data-mp="11lqd04i1arpq">
              <h3 className="font-display text-3xl leading-none text-lime sm:text-4xl" data-id="element-184" data-mp="11ikl6hi0tbqb">
                MegaPack Árabe <span className="text-gold" data-id="element-185" data-mp="1u9m66z8ea1hr">PRO</span>
              </h3>
              <p className="mt-1.5 text-sm font-bold text-snow" data-id="element-186" data-mp="1u8t7mljlaiap">
                {megapack.description} <span className="text-lime" data-id="element-187" data-mp="1pb14evdhv9r7">+ 5 bonos exclusivos gratis</span>
              </p>
            </header>

            <div className="mt-6 rounded-2xl border border-ink-line bg-ink p-4 sm:p-5" data-id="element-188" data-mp="1lb0t3jlozeod">
              <h4 className="text-[11px] font-extrabold uppercase tracking-[0.18em] text-snow-dim" data-id="element-189" data-mp="1g9jtdrey1y9d">
                Resumen del pedido
              </h4>

              <div className="mt-3 flex items-start justify-between gap-4 border-b border-ink-line pb-3.5" data-id="element-190" data-mp="4u4tofvcosak">
                <div data-id="element-191" data-mp="6bjypig5gvyx">
                  <p className="text-sm font-bold text-snow sm:text-base" data-id="element-192" data-mp="6cd0s645yxaq">{megapack.name}</p>
                  <span className="mt-1.5 inline-flex items-center gap-1 rounded-full bg-lime/10 px-2.5 py-0.5 text-xs font-bold text-lime" data-id="element-193" data-mp="b9lmggoitjgq">
                    <GiftIcon className="h-3 w-3" aria-hidden="true" data-id="element-194" data-mp="3tivxk1qtce2i" /> +5 bonos gratis
                  </span>
                </div>
                <span className="whitespace-nowrap text-sm font-bold text-snow sm:text-base" data-id="element-195" data-mp="3jqgc2ugb57cv">{megapack.price}</span>
              </div>

              <ul className="space-y-2.5 border-b border-ink-line py-3.5" aria-label="Bonos incluidos" data-id="element-196" data-mp="3oj16ny71fohg">
                {BONOS.map(bono => <li key={bono.n} className="flex items-center justify-between gap-3 text-sm" data-id="element-197" data-mp="39qpiqw3hgyed">
                    <span className="min-w-0 truncate text-snow-muted" data-id="element-198" data-mp="3epahss701c18">
                      Bono #{bono.n}: {bono.title}
                    </span>
                    <span className="flex flex-shrink-0 items-center gap-2" data-id="element-199" data-mp="35px5zsvekbdc">
                      <span className="whitespace-nowrap text-xs text-snow-dim line-through" data-id="element-200" data-mp="2m4n7fuxmxkk3">{bono.price}</span>
                      <span className="rounded bg-lime px-1.5 py-0.5 text-[10px] font-extrabold uppercase tracking-wide text-ink" data-id="element-201" data-mp="2h6vin9saeek4">
                        Gratis
                      </span>
                    </span>
                  </li>)}
              </ul>

              <div className="flex items-end justify-between gap-4 pt-3.5" data-id="element-202" data-mp="2r6mbl7178li3">
                <span className="text-sm font-semibold text-snow-muted" data-id="element-203" data-mp="3526l5bv1frcu">Precio total</span>
                <div className="text-right" data-id="element-204" data-mp="304es2einpz72">
                  {!isExpired && <p className="text-sm text-snow-dim line-through" data-id="element-205" data-mp="3euca0cpztsnt">{PRICING.totalValueOld}</p>}
                  <p className="font-display text-4xl leading-none text-snow sm:text-5xl" data-id="element-206" data-mp="39u7timp34xxl">{megapack.price}</p>
                  {!isExpired && <p className="mt-1.5 text-sm font-extrabold text-lime" data-id="element-207" data-mp="3nvk56lx7qddo">Ahorrás {PRICING.savings}</p>}
                </div>
              </div>
            </div>

            <p className="mt-4 text-center text-xs font-extrabold uppercase tracking-[0.16em] text-snow" data-id="element-208" data-mp="1h6i7y1pnfu0i">
              {isExpired ? 'Precio actualizado · un único pago' : 'Un único pago · sin suscripciones'}
            </p>

            <CtaButton variant="lime" className="mt-5 w-full" href={megapack.checkoutUrl} data-id="element-209" data-mp="1qvthfpgg70ox">
              Quiero MegaPack Árabe PRO — {megapack.price}
              <ArrowRightIcon className="h-4 w-4 flex-shrink-0" aria-hidden="true" data-id="element-210" data-mp="1uzhmo1hlxk70" />
            </CtaButton>

            <p className="mt-3 flex items-center justify-center gap-2 text-xs font-semibold text-snow-muted" data-id="element-211" data-mp="136h7uoh7kqm3">
              <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-212" data-mp="178c8dqrbezyt" />
              Acceso inmediato · Pago único · Acceso de por vida
            </p>
          </article>
        </Reveal>
      </div>
    </section>;
}